// extracted by mini-css-extract-plugin
export default {"wrapper":"WM","content":"XM","firstSection":"YM","text":"ZM","table":"aN","tableText":"bN","row":"cN","column_2":"eN","column_1":"fN","column_3":"gN"};
    if(module.hot) {
      // 1737143662505
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  